import { format } from 'date-fns';

export default (stateDate, itineraryDate) => {
  if (stateDate) return stateDate;
  if (itineraryDate) return format(itineraryDate, 'DD/MM/YYYY');
  return '';
};
